import { PROTOCOL_VERSION } from "./version";
/**
 * The keepalive as the exact text on the wire (review 0027 D4). The table answers a ping without
 * waking up, and the platform matches it letter for letter, so client and server take the text
 * from here. A client of another protocol version sends another text: it is not answered
 * automatically and reaches the table like any message.
 */
export const PING_FRAME = JSON.stringify({ v: PROTOCOL_VERSION, type: "ping" });
export const PONG_FRAME = JSON.stringify({ v: PROTOCOL_VERSION, type: "pong" });
//# sourceMappingURL=keepalive.js.map